interface AboutProps {
  onOpenModal?: () => void;
}

export default function About({ onOpenModal }: AboutProps) {
  const resources = [
    { icon: 'ri-box-3-line', name: '3D Modeling' },
    { icon: 'ri-building-line', name: 'BIM Modeling' },
    { icon: 'ri-file-text-line', name: 'Design Documentation' },
    { icon: 'ri-file-list-3-line', name: 'Working Documentation' },
    { icon: 'ri-folder-line', name: 'Construction Documentation (RKD)' },
    { icon: 'ri-cpu-line', name: 'APCS Automation' },
    { icon: 'ri-code-line', name: 'Software Development' },
    { icon: 'ri-tools-line', name: 'Assembly Area' },
    { icon: 'ri-dashboard-line', name: 'Control Cabinets' },
  ];

  const departments = [
    { icon: 'ri-flask-line', name: 'Technological Department' },
    { icon: 'ri-pencil-ruler-2-line', name: 'Engineering Design Department' },
    { icon: 'ri-flashlight-line', name: 'APCS & Electrical' },
    { icon: 'ri-settings-3-line', name: 'Assembly Site' },
    { icon: 'ri-tools-line', name: 'Installation & Commissioning' },
  ];

  return (
    <section id="about" className="bg-gradient-to-br from-white via-[#F5F9FF] to-[#EDF4FF] py-16 sm:py-24 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">

        {/* Section Label */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-[2px] bg-[#0066FF]"></div>
          <span className="text-xs uppercase tracking-[3px] text-[#0066FF] font-bold">About Us</span>
        </div>

        <h2 className="text-[32px] sm:text-[40px] lg:text-[52px] font-black text-[#0A1628] uppercase leading-none mb-10 sm:mb-16 tracking-tight">
          A&R CONSULTING
        </h2>

        {/* Bottom Row: text + resources + departments */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

          {/* Company description card */}
          <div className="rounded-[24px] border border-gray-200 p-6 sm:p-8 lg:p-10 flex flex-col justify-between">
            <div>
              <div className="text-xs uppercase tracking-[3px] text-[#0066FF] font-bold mb-6">Our Mission</div>
              <p className="text-[15px] text-[#4A5568] leading-relaxed mb-6">
                LLC "A&R Consulting" provides high-quality solutions in water treatment and wastewater purification.
              </p>
              <p className="text-[15px] text-[#4A5568] leading-relaxed">
                We build long-term partnerships based on trust, technical excellence, and commitment to environmental sustainability.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-gray-100">
              <div className="text-xs uppercase tracking-[2px] text-[#0A1628] font-bold mb-3">Our Values</div>
              <div className="text-sm text-[#4A5568]">Respect for clients, employees, and the company.</div>
            </div>
          </div>

          {/* Engineering Resources — icon card */}
          <div className="rounded-[24px] bg-[#F7FAFF] p-6 sm:p-8 lg:p-10">
            <div className="text-xs uppercase tracking-[3px] text-[#0066FF] font-bold mb-6">Engineering Resources</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {resources.map((resource, index) => (
                <div key={index} className="flex flex-col items-center gap-2 p-3 bg-white rounded-[12px] border border-[#E8F0FF] hover:border-[#0066FF] transition-colors cursor-pointer">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${resource.icon} text-[20px] text-[#0066FF]`}></i>
                  </div>
                  <div className="text-[10px] font-semibold text-[#0A1628] text-center leading-tight">{resource.name}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Organizational Structure */}
          <div className="rounded-[24px] bg-[#0A1628] p-6 sm:p-8 lg:p-10 flex flex-col">
            <div className="text-xs uppercase tracking-[3px] text-[#00D4FF] font-bold mb-6">Organizational Structure</div>
            <div className="flex flex-col gap-3 flex-1">
              {departments.map((dept, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 rounded-[12px] bg-white/5 border border-white/10 transition-colors hover:bg-white/10"
                >
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`${dept.icon} text-[18px] text-[#00D4FF]`}></i>
                  </div>
                  <span className="text-sm font-semibold text-white flex-1">{dept.name}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
